<template>
  <el-form :inline="true" :model="form">
    <el-form-item label="时间：从">
      <el-date-picker
        v-model="form.dateFrom"
        type="date"
        placeholder="选择开始日期"
      ></el-date-picker>
    </el-form-item>
    <el-form-item label="到">
      <el-date-picker
        v-model="form.dateTo"
        type="date"
        placeholder="选择结束日期"
      ></el-date-picker>
    </el-form-item>
    <el-form-item label="关键字">
      <el-input v-model="form.keyword" placeholder="关键字"></el-input>
    </el-form-item>

    <el-form-item>
      <el-button type="primary" @click.prevent="btnSearchClick">查询</el-button>
    </el-form-item>
  </el-form>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

interface IForm {
  dateFrom: string;
  dateTo: string;
  keyword: string;
}

interface IState {
  form: IForm;
}

export default defineComponent({
  emits: ['search'],
  data() {
    return {
      form: {
        dateFrom: '',
        dateTo: '',
        keyword: '',
      },
    } as IState;
  },
  methods: {
    btnSearchClick() {
      this.$emit('search', this.form);
    },
  },
});
</script>
